import apiClient from './api';
import type {
  Project,
  CreateProjectPayload,
  ApiResponse,
} from '../types/api.types';

export const projectsService = {
  // Get all projects for authenticated user
  async getProjects(): Promise<Project[]> {
    const response = await apiClient.get<Project[]>('/retrieve/projects');
    return response.data;
  },

  // Get single project by ID
  async getProjectById(projectId: number): Promise<Project> {
    const response = await apiClient.get<Project>(`/retrieve/project/${projectId}`);
    return response.data;
  },

  // Get single project by ID (alias for compatibility)
  async getProject(projectId: number): Promise<Project> {
    return this.getProjectById(projectId);
  },

  // Create new project
  async createProject(payload: CreateProjectPayload): Promise<ApiResponse> {
    const response = await apiClient.post<ApiResponse>('/save/project', payload);
    return response.data;
  },

  // Delete project (soft delete)
  async deleteProject(projectId: number): Promise<ApiResponse> {
    const response = await apiClient.post<ApiResponse>(`/delete/project/${projectId}`);
    return response.data;
  },
};
